import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ICustomDialogOptions } from './custom-dialog-options.interface';
// import { UtilsService } from '../../index';

@Component({
  selector: 'app-custom-dialog',
  // encapsulation: ViewEncapsulation.None,
  templateUrl: 'custom-dialog.component.html',
  styleUrls: ['custom-dialog.component.scss']
})

export class CustomDialogComponent implements OnInit, OnDestroy {
  dialog: MatDialogRef<any>;
  modalOptions!: ICustomDialogOptions;

  constructor(
    public dialogRef: MatDialogRef<any>,
    // private _utilsService: UtilsService
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.modalOptions.title = this.modalOptions.title ?? 'Confirmacion';
    this.modalOptions.message = this.modalOptions.message ?? 'Esta seguro?';
    this.modalOptions.showYesAll = this.modalOptions.showYesAll ?? false;
    this.modalOptions.yesAllButtonLabel = this.modalOptions.yesAllButtonLabel ?? 'Si';
    this.modalOptions.yesButtonLabel = this.modalOptions.yesButtonLabel ?? 'Si';
    this.modalOptions.noButtonLabel = this.modalOptions.noButtonLabel ?? 'No';
    this.modalOptions.colorYesAllButton = this.modalOptions.colorYesAllButton ?? "#0d47a1";
    // this._utilsService.disableBodyScroll();
  }

  ngOnDestroy() {
    // this._utilsService.enableBodyScroll();
  }
}
